import React, { useEffect, useState } from 'react';
import { BaseModal, BaseModalProps } from '@tcl-argon-foundations/base-modal';
import { Close } from '@tcl-argon-icons/icons';
import { mergeClasses } from '@tcl-argon-utils/utils';
import { useOverlayStyles } from './styles';

export interface OverlayProps extends Omit<BaseModalProps, 'contentLabel' | 'onRequestClose'> {
  /** Overlays have an "X" button in the top-right. If a user clicks that, this handler is triggered. */
  onRequestClose?: () => void;
}

export const Overlay: React.FC<OverlayProps> = ({
  children,
  classes: classOverrides,
  className,
  isOpen,
  onRequestClose,
  ...props
}) => {
  const [isTransitionedIn, setIsTransitionedIn] = useState(false);
  const classes = mergeClasses(useOverlayStyles({ isTransitionedIn }), classOverrides, { root: className as string });

  useEffect(() => {
    if (isOpen) {
      setIsTransitionedIn(true);
    }
  }, [isOpen]);

  const transitionOut = () => {
    setIsTransitionedIn(false);

    const id = window.setTimeout(() => {
      onRequestClose();
    }, 300);

    return () => clearTimeout(id);
  };

  return (
    <BaseModal
      classes={classes}
      isOpen={isOpen}
      // Technically unnecessary because the overlay is hidden, but kept because it's explicit
      shouldCloseOnOverlayClick={false}
      onRequestClose={() => {}}
      data-analytics="overlay"
      {...props}
    >
      {onRequestClose && (
        <button className={classes.closeButton} onClick={transitionOut}>
          <Close height="15px" width="15px" />
        </button>
      )}
      {children}
    </BaseModal>
  );
};
